import { BuilderTypes } from "./BuilderTypes";

export enum MergeInstructionType {
    EXCLUDE_FROM_MERGE = "exclude",
    IGNORE_CONFLICTS = "ignore",
    INCLUDE = "include",
}

export class MergeInstructions {
    type: BuilderTypes;
    id: string;
    instruction: MergeInstructionType;

    constructor(type: BuilderTypes, id: string, instruction: MergeInstructionType) {
        this.type = type;
        this.id = id;
        this.instruction = instruction;
    }
}
